import React, { memo }  from 'react';
import IconWrapper from '../IconWrapper';

const IconCheckmark = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#4abfad"} className={`checkmark ${props.className}`} viewBox="0 0 12 8">
        <polygon points="4.13041667 6.26041667 1.69791667 3.82791667 0.869583333 4.65041667 4.13041667 7.91125 11.1304167 0.91125 10.3079167 0.08875"></polygon>
    </IconWrapper>
);

export default memo(IconCheckmark);
